'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from './utils';
import refObject from '../utils/propTypes/refObject';
export default function (Component) {
  const ShareScrollElementComponent = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      scrollElementRef
    } = props,
          rest = _objectWithoutPropertiesLoose(props, ["scrollElementRef"]);

    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, rest, {
      scrollElementRef: scrollElementRef || defaultRef,
      ref: ref
    }));
  });
  const componentName = getComponentName(Component);
  ShareScrollElementComponent.displayName = `ShareScrollElement(${componentName})`;
  ShareScrollElementComponent.propTypes = Object.assign({}, Component.propTypes, {
    scrollElementRef: refObject
  });
  ShareScrollElementComponent.defaultProps = Component.defaultProps;
  attachWrappedComponent(ShareScrollElementComponent, Component);
  return ShareScrollElementComponent;
}